import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { deleteControlTextMatches } from './student-lifecycle'

/**
 * TR-1101 delete (anonymize) dialog: the operator must type the student's public login
 * exactly to arm the irreversible action. The typed value is controlled by the caller so a
 * reopen starts blank; the caller owns the mutation and surfaces server errors (400 mismatch,
 * 409 pending sheet).
 */
export function DeleteStudentDialog({
  open,
  onOpenChange,
  login,
  typed,
  onTypedChange,
  pending,
  error,
  onConfirm,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  login: string
  typed: string
  onTypedChange: (value: string) => void
  pending?: boolean
  error?: string | null
  onConfirm: () => void
}) {
  const matches = deleteControlTextMatches(typed, login)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Usunięcie konta ucznia</DialogTitle>
          <DialogDescription>
            Ta operacja jest nieodwracalna. Konto zostanie zanonimizowane: login i dane kontaktowe
            znikną, a powiązanie z klasą zostanie zerwane. Historia punktów, postępy i odznaki
            pozostaną pod anonimowym identyfikatorem. Aby potwierdzić, wpisz dokładnie login ucznia.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label htmlFor="delete-student-code">
            Login: <span className="font-mono font-medium">{login}</span>
          </Label>
          <Input
            id="delete-student-code"
            value={typed}
            onChange={(e) => onTypedChange(e.target.value)}
            autoComplete="off"
            autoCapitalize="off"
            spellCheck={false}
            placeholder="Wpisz login ucznia"
          />
        </div>
        {error && <p className="text-sm text-destructive">{error}</p>}
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={pending}
          >
            Anuluj
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={onConfirm}
            disabled={!matches || pending}
          >
            Usuń konto
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
